import { messaging } from "../database/firebase";
import audios from "../resources/audios";
const soundURL =
  "https://freesound.org/data/previews/266/266566_4900575-lq.mp3";
export let audio = new Audio(soundURL);
export const sendNotification = (title, body, icon, loopingSound) => {
  var options = {
    body: body,
    icon,
  };
  var notification = new Notification(title, options);

  audio.play();
  if (loopingSound) audio.loop = true;
};
function playSound(url) {
  const audio = new Audio(url);

  // audio.loop = true;
  audio.play();
  audio.loop = true;
}
export const showNotification = (title, body, icon, loopingSound) => {
  console.log("Displaying notification");

  if (!("Notification" in window)) {
    alert("Este navegador no soporta las notificaciones del sistema");
  }

  // Comprobamos si ya nos habían dado permiso
  else if (Notification.permission === "granted") {
    // Si esta correcto lanzamos la notificación
    sendNotification(title, body, icon, loopingSound);
  }

  // Si no, tendremos que pedir permiso al usuario
  else if (Notification.permission !== "denied") {
    Notification.requestPermission().then(function (permission) {
      // Si el usuario acepta, lanzamos la notificación
      if (permission === "granted") {
        var notification = sendNotification(title, body, icon, loopingSound);
      }
    });
  }
};

export const getToken = (setTokenFound) => {
  // Push is unavailable on iOS Safari unless running as an installed PWA on iOS 16+.
  const pushSupported =
    messaging &&
    typeof Notification !== "undefined" &&
    "serviceWorker" in navigator;

  if (!pushSupported) {
    console.log("Push notifications are not supported in this browser.");
    setTokenFound(null);
    return Promise.resolve(null);
  }

  return messaging
    .getToken()
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        setTokenFound(currentToken);
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        setTokenFound(currentToken);
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};
